import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgencyContactDetails, AgencyDashboard, ContractorsByLicense } from '@app/models/';
import { RoleEntryResponse, RoleListResponse, RoleSaveRequest } from '@app/models/role-admin.model';
import {
  ManagedUserEntryResponse,
  ManagedUserListResponse,
  ManagedUserSaveRequest,
} from '@app/models/user-admin.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgencyService {
  constructor(private http: HttpClient) {}

  getAgencyContactDetails(query = ''): Observable<AgencyContactDetails[]> {
    return this.http.get<AgencyContactDetails[]>(`${environment.apiUrl}/api/pub/Agency/GetClientContacts`, {
      params: { query },
    });
  }

  getAgencyDashboards(): Observable<AgencyDashboard[]> {
    return this.http.get<AgencyDashboard[]>(`${environment.apiUrl}/api/agency/Agency/GetAgencyDashboards`);
  }

  getContractorsByLicense(questionnaireTypeId: number): Observable<ContractorsByLicense[]> {
    return this.http.get<ContractorsByLicense[]>(`${environment.apiUrl}/api/Report/GetSubmittedVendors`, {
      params: { questionnaireTypeId: questionnaireTypeId },
    });
  }

  getRoles(sortColumn = 'name', sortAtoZ = true): Observable<RoleListResponse> {
    return this.http.post<RoleListResponse>(`${environment.apiUrl}/api/UserRoleManagement/RoleAdminPageContent`, {
      sortColumn,
      sortAtoZ,
    });
  }

  getRole(roleId: number): Observable<RoleEntryResponse> {
    return this.http.post<RoleEntryResponse>(`${environment.apiUrl}/api/UserRoleManagement/RoleEntryContent`, roleId);
  }

  saveRole(role: RoleSaveRequest): Observable<number> {
    return this.http.post<number>(`${environment.apiUrl}/api/UserRoleManagement/SubmitRoleAdminForm`, role);
  }

  getManagedUsers(sortColumn = 'name', sortAtoZ = true): Observable<ManagedUserListResponse> {
    return this.http.post<ManagedUserListResponse>(
      `${environment.apiUrl}/api/UserRoleManagement/UserAdminPageContent`,
      {
        sortColumn,
        sortAtoZ,
      }
    );
  }

  getManagedUser(userId: number): Observable<ManagedUserEntryResponse> {
    return this.http.get<ManagedUserEntryResponse>(`${environment.apiUrl}/api/UserRoleManagement/UserEntryContent`, {
      params: { userId },
    });
  }

  saveManagedUser(user: ManagedUserSaveRequest): Observable<number> {
    return this.http.post<number>(`${environment.apiUrl}/api/UserRoleManagement/SubmitAgencyUser`, user);
  }

  resendUserInvite(userId: number): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/api/UserRoleManagement/ResendConfirmEmail`, userId);
  }
}
